const mediaCoreFromProductCardSrc = (src) => {
  if (!src) return "";
  try {
    const url = new URL(src, window.location.origin);
    const file = decodeURIComponent(url.pathname.split("/").pop() || "");
    return file.replace(/\.[a-z0-9]+$/i, "").split("_")[0];
  } catch (error) {
    const file = String(src).split("?")[0].split("/").pop() || "";
    return file.replace(/\.[a-z0-9]+$/i, "").split("_")[0];
  }
};

const productCardFilename = (src) => {
  if (!src) return "";
  try {
    return decodeURIComponent(new URL(src, window.location.origin).pathname.split("/").pop() || "");
  } catch (error) {
    return String(src).split("?")[0].split("/").pop() || "";
  }
};

const isPreferredProductCard01 = (media) => {
  const src = media?.preview_image?.src || media?.src || "";
  return /\bfront view\b/i.test(media?.alt || "") || /-01_[^/.]+\.[a-z0-9]+$/i.test(productCardFilename(src));
};

const stableMediaPath = (src) => {
  if (!src) return "";
  try {
    return decodeURIComponent(new URL(src, window.location.origin).pathname || "");
  } catch (error) {
    return String(src).split("?")[0];
  }
};

const merchandisingMediaForVariant = (product, variant) => {
  // Spring Step Shoes merchandising rule:
  // Keep the Shopify variant featured media on product cards.
  // Variant media is intentionally assigned to view 05 for PLP/editorial merchandising,
  // while view 01 remains first in product media for the PDP/canonical gallery.
  return variant?.featured_media || null;
};

const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading = "lazy";
  return newImage;
};

const cardVariantStorageKey = (wrapper) => `sss-card-variant:${wrapper?.dataset?.product || ""}`;

const updateCardVariantLinks = (wrapper, variantLink) => {
  if (!wrapper || !variantLink) return;
  wrapper.dataset.sssSelectedVariantLink = variantLink;
  wrapper.querySelectorAll(".card-wrapper__link--overlay, .card__title a, .js-color-swatches-link, .card-horizontal__title a").forEach((link) => {
    link.setAttribute("href", variantLink);
  });
  const quickViewButton = wrapper.querySelector(".quick-add-view");
  if (quickViewButton) quickViewButton.setAttribute("data-product-url", variantLink);
};

const rememberCardVariant = (wrapper, input) => {
  if (!wrapper || !input) return;
  const state = {
    variantId: input.dataset.variantId || "",
    variantLink: input.dataset.variantLink || "",
    color: input.value || ""
  };
  try {
    sessionStorage.setItem(cardVariantStorageKey(wrapper), JSON.stringify(state));
  } catch (error) {}
};

const restoreCardVariant = (wrapper) => {
  if (!wrapper?.dataset?.product) return;
  let state = null;
  try {
    state = JSON.parse(sessionStorage.getItem(cardVariantStorageKey(wrapper)) || "null");
  } catch (error) {}
  if (!state) return;
  const inputs = Array.from(wrapper.querySelectorAll(".js-color-swatches input"));
  const input = inputs.find((item) => {
    if (state.variantId && item.dataset.variantId === state.variantId) return true;
    if (state.variantLink && item.dataset.variantLink === state.variantLink) return true;
    return state.color && item.value === state.color;
  });
  if (!input) return;
  input.checked = true;
  updateCardVariantLinks(wrapper, input.dataset.variantLink || state.variantLink);
  input.click();
};

const checkSwatches = (scope = document) => {
  const wrappers = scope.matches?.(".js-color-swatches-wrapper")
    ? [scope]
    : Array.from(scope.querySelectorAll?.(".js-color-swatches-wrapper") || []);
  wrappers.forEach((wrapper) => {
    const inputs = Array.from(wrapper.querySelectorAll(".js-color-swatches input"));
    inputs.forEach((input) => {
      if (input.dataset.sssColorSwatchBound === "true") return;
      input.dataset.sssColorSwatchBound = "true";
      input.addEventListener("click", (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const handleProduct = wrapper.dataset.product;
        if (!event.currentTarget.checked || !primaryImage) return;

        updateCardVariantLinks(wrapper, event.currentTarget.dataset.variantLink);
        rememberCardVariant(wrapper, event.currentTarget);

        const addButton = wrapper.querySelector('.card__add-to-cart button[name="add"]');
        if (addButton) {
          addButton.setAttribute("aria-disabled", false);
          addButton.querySelector('span')?.classList.remove("hidden");
          addButton.querySelector('.sold-out-message')?.classList.add("hidden");
          const variantInput = wrapper.querySelector('.card__add-to-cart input[name="id"]');
          if (variantInput) variantInput.value = event.currentTarget.dataset.variantId;
        }

        const currentColor = event.currentTarget.value;
        const requestVersion = Number(wrapper.dataset.sssColorRequestVersion || "0") + 1;
        wrapper.dataset.sssColorRequestVersion = String(requestVersion);

        jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
          if (String(requestVersion) !== wrapper.dataset.sssColorRequestVersion) return;
          const variant = product.variants.find((item) => item.featured_media != null && item.options.includes(currentColor));
          if (!variant) return;
          const displayMedia = merchandisingMediaForVariant(product, variant);
          if (!displayMedia?.preview_image?.src) return;

          const currentPrimary = wrapper.querySelector(".media--first");
          const currentSecondary = wrapper.querySelector(".media--second");
          if (!currentPrimary) return;
          const nextPath = stableMediaPath(displayMedia.preview_image.src);
          const currentPath = stableMediaPath(currentPrimary.currentSrc || currentPrimary.src);
          if (nextPath && currentPath && nextPath === currentPath) return;

          const newPrimaryImage = createImageElement(displayMedia, currentPrimary.className, currentPrimary.sizes, product.title);
          if (currentSecondary) {
            const secondaryPath = stableMediaPath(currentSecondary.currentSrc || currentSecondary.src);
            if (secondaryPath && secondaryPath === nextPath) {
              currentPrimary.remove();
              currentSecondary.classList.remove("media--second");
              currentSecondary.classList.add("media--first");
              return;
            }
          }

          currentPrimary.getAnimations().forEach((animation) => animation.cancel());
          currentPrimary.animate({ opacity: [1, 0] }, { duration: 120, easing: "ease-out", fill: "forwards" });
          window.setTimeout(() => {
            if (!currentPrimary.isConnected) return;
            currentPrimary.replaceWith(newPrimaryImage);
            newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 120, easing: "ease-out" });
            currentSecondary?.remove();
          }, 120);
        });
      });
    });
    if (inputs.length && wrapper.dataset.sssColorRestored !== "true") {
      wrapper.dataset.sssColorRestored = "true";
      restoreCardVariant(wrapper);
    }
  });
};


const forceCardVariantSelection = (input) => {
  const wrapper = input?.closest?.(".js-color-swatches-wrapper");
  if (!wrapper || !input.checked) return;

  updateCardVariantLinks(wrapper, input.dataset.variantLink);
  rememberCardVariant(wrapper, input);

  const variantInput = wrapper.querySelector('.card__add-to-cart input[name="id"]');
  if (variantInput && input.dataset.variantId) variantInput.value = input.dataset.variantId;

  const handleProduct = wrapper.dataset.product;
  if (!handleProduct) return;

  const requestVersion = Number(wrapper.dataset.sssColorRequestVersion || "0") + 1;
  wrapper.dataset.sssColorRequestVersion = String(requestVersion);

  jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
    if (String(requestVersion) !== wrapper.dataset.sssColorRequestVersion) return;

    const wantedId = String(input.dataset.variantId || "");
    const currentColor = input.value;
    const variant = product.variants.find((item) => String(item.id) === wantedId)
      || product.variants.find((item) => item.featured_media != null && item.options.includes(currentColor));
    if (!variant) return;

    const displayMedia = merchandisingMediaForVariant(product, variant) || variant.featured_media;
    if (!displayMedia?.preview_image?.src) return;

    const currentPrimary = wrapper.querySelector(".media--first");
    if (!currentPrimary) return;

    const newPrimaryImage = createImageElement(
      displayMedia,
      currentPrimary.className,
      currentPrimary.sizes,
      product.title
    );

    const currentSecondary = wrapper.querySelector(".media--second");
    currentPrimary.getAnimations().forEach((animation) => animation.cancel());
    currentPrimary.replaceWith(newPrimaryImage);
    currentSecondary?.remove();

    const selectedUrl = input.dataset.variantLink || `${window.Shopify.routes.root}products/${handleProduct}?variant=${variant.id}`;
    updateCardVariantLinks(wrapper, selectedUrl);
  });
};

const delegatedCardSwatches = () => {
  if (document.documentElement.dataset.sssDelegatedCardSwatches === "true") return;
  document.documentElement.dataset.sssDelegatedCardSwatches = "true";

  const syncFromEvent = (event) => {
    const input = event.target?.matches?.(".js-color-swatches input")
      ? event.target
      : event.target?.closest?.("label")?.control;
    if (!input?.matches?.(".js-color-swatches input")) return;
    window.setTimeout(() => forceCardVariantSelection(input), 0);
  };

  document.addEventListener("change", syncFromEvent, true);
  document.addEventListener("click", syncFromEvent, true);
};


const sssNormalizeOption = (value) => String(value || "").replace(/\s+/g, " ").trim().toLowerCase();

const sssCardForSwatchKingItem = (item) => {
  if (!item) return null;
  return item.closest(".js-color-swatches-wrapper[data-product]")
    || item.closest(".card-wrapper[data-product]")
    || item.parentElement?.closest?.(".js-color-swatches-wrapper[data-product]")
    || null;
};

const sssSwatchKingValue = (item) => {
  if (!item) return "";
  const candidates = [
    item.dataset?.value,
    item.dataset?.optionValue,
    item.dataset?.swatchValue,
    item.getAttribute?.("data-value"),
    item.getAttribute?.("data-option-value"),
    item.getAttribute?.("aria-label"),
    item.getAttribute?.("title"),
    item.querySelector?.("[data-value]")?.getAttribute?.("data-value"),
    item.querySelector?.("[data-option-value]")?.getAttribute?.("data-option-value"),
    item.querySelector?.(".swatch-button-title-text")?.textContent,
    item.querySelector?.("img")?.alt,
    item.querySelector?.("img")?.title
  ];
  return String(candidates.find((value) => String(value || "").trim()) || "").trim();
};

const sssApplyResolvedVariantToCard = (wrapper, product, variant) => {
  if (!wrapper || !product || !variant) return;
  const displayMedia = merchandisingMediaForVariant(product, variant) || variant.featured_media;
  const preview = displayMedia?.preview_image || displayMedia;
  if (!preview?.src) return;

  const primary = wrapper.querySelector("img.media--first, .media--first img");
  if (primary) {
    const next = createImageElement(
      { preview_image: preview, alt: displayMedia?.alt || "" },
      primary.className,
      primary.sizes,
      product.title
    );
    primary.getAnimations?.().forEach((animation) => animation.cancel());
    primary.replaceWith(next);
    wrapper.querySelectorAll(".media--second").forEach((node) => node.remove());
  }

  const variantUrl = `${window.Shopify?.routes?.root || "/"}products/${encodeURIComponent(wrapper.dataset.product)}?variant=${variant.id}`;
  updateCardVariantLinks(wrapper, variantUrl);
  wrapper.querySelectorAll('a[href*="/products/"]').forEach((link) => link.setAttribute("href", variantUrl));
  wrapper.querySelectorAll("[data-product-url]").forEach((el) => el.setAttribute("data-product-url", variantUrl));
  const hidden = wrapper.querySelector('.card__add-to-cart input[name="id"]');
  if (hidden) hidden.value = variant.id;
  wrapper.dataset.sssSelectedVariantId = String(variant.id);
};

const sssResolveSwatchKingVariant = async (wrapper, rawValue) => {
  const handle = wrapper?.dataset?.product;
  if (!handle || !rawValue) return;
  const normalized = sssNormalizeOption(rawValue);
  const root = window.Shopify?.routes?.root || "/";
  try {
    const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { credentials: "same-origin" });
    if (!response.ok) return;
    const product = await response.json();
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    const matches = variants.filter((variant) =>
      Array.isArray(variant.options) && variant.options.some((option) => sssNormalizeOption(option) === normalized)
    );
    const variant = matches.find((item) => item.available !== false && item.featured_media?.preview_image?.src)
      || matches.find((item) => item.featured_media?.preview_image?.src)
      || matches.find((item) => item.available !== false)
      || matches[0];
    if (!variant) return;
    sssApplyResolvedVariantToCard(wrapper, product, variant);
    try {
      sessionStorage.setItem(cardVariantStorageKey(wrapper), JSON.stringify({
        variantId: String(variant.id),
        variantLink: `${root}products/${encodeURIComponent(handle)}?variant=${variant.id}`,
        color: rawValue
      }));
    } catch (error) {}
  } catch (error) {}
};

const bindSwatchKingCards = () => {
  if (document.documentElement.dataset.sssSwatchKingCards === "true") return;
  document.documentElement.dataset.sssSwatchKingCards = "true";

  const handle = (event) => {
    const item = event.target?.closest?.(".swatch-view-item, .swatch-button");
    if (!item) return;
    const swatchItem = item.matches(".swatch-view-item") ? item : item.closest(".swatch-view-item") || item;
    const wrapper = sssCardForSwatchKingItem(swatchItem);
    if (!wrapper) return;
    const value = sssSwatchKingValue(swatchItem);
    if (!value) return;
    window.setTimeout(() => sssResolveSwatchKingVariant(wrapper, value), 20);
    window.setTimeout(() => sssResolveSwatchKingVariant(wrapper, value), 220);
  };

  document.addEventListener("click", handle, true);
  document.addEventListener("change", handle, true);
};

function colorSwatches() {
  checkSwatches();
  document.addEventListener("shopify:section:load", function (event) {
    checkSwatches(event.target || document);
  });

  const observe = () => {
    if (!document.body) return;
    const observer = new MutationObserver((mutations) => {
      const wrappers = new Set();
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches(".js-color-swatches-wrapper")) wrappers.add(node);
          node.querySelectorAll?.(".js-color-swatches-wrapper").forEach((wrapper) => wrappers.add(wrapper));
          const parentWrapper = node.closest?.(".js-color-swatches-wrapper");
          if (parentWrapper) wrappers.add(parentWrapper);
        });
      });
      wrappers.forEach((wrapper) => checkSwatches(wrapper));
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observe, { once: true });
  } else {
    observe();
  }
}

(function () { colorSwatches(); delegatedCardSwatches(); bindSwatchKingCards(); })();

/* Spring Step Shoes — global media stability guard (Sep 11, 2026) */
(function () {
  if (typeof VariantSelects === "undefined" || !VariantSelects.prototype) return;
  if (VariantSelects.prototype.__sssMediaStabilityPatched) return;
  VariantSelects.prototype.__sssMediaStabilityPatched = true;

  const mediaIdTail = (value) => {
    const match = String(value || "").match(/(\d+)(?!.*\d)/);
    return match ? match[1] : String(value || "");
  };
  const mediaSignature = (root) => {
    if (!root) return "";
    return Array.from(root.querySelectorAll("[data-media-id]"))
      .map((el) => mediaIdTail(el.dataset.mediaId))
      .filter(Boolean)
      .join("|");
  };

  const originalUpdateMedia = VariantSelects.prototype.updateMedia;
  VariantSelects.prototype.updateMedia = function (mediaId = null) {
    if (!this.currentVariant?.featured_media) return;
    const scope = typeof this.getUpdateScope === "function" ? this.getUpdateScope() : document;
    const targetMediaId = mediaId || `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
    const targetTail = mediaIdTail(targetMediaId);
    const isQuickView = scope !== document;
    const wrappers = isQuickView
      ? scope.querySelectorAll(".product__media-wrapper, .global-variant-slider, .quick-product__media-list")
      : document.querySelectorAll(".product__media-wrapper, .global-variant-slider");

    let needsMove = wrappers.length === 0;
    wrappers.forEach((wrapper) => {
      if (isQuickView && !wrapper.closest("quick-add-modal")) return;
      if (!isQuickView && wrapper.closest("quick-add-modal")) return;
      const list = wrapper.querySelector(".js-media-list, .global-variant-js-media-list, .quick-js-media-list");
      if (list?.swiper) {
        const active = list.swiper.slides?.[list.swiper.activeIndex];
        if (mediaIdTail(active?.dataset?.mediaId) !== targetTail) needsMove = true;
      } else {
        const first = wrapper.querySelector("[data-media-id]");
        if (first && mediaIdTail(first.dataset.mediaId) !== targetTail) needsMove = true;
      }
    });
    if (!needsMove) return;
    return originalUpdateMedia.call(this, mediaId);
  };

  const originalUpdateElementsAfterFetch = VariantSelects.prototype.updateElementsAfterFetch;
  VariantSelects.prototype.updateElementsAfterFetch = function (html) {
    const destinationScope = typeof this.getUpdateScope === "function" ? this.getUpdateScope() : document;
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection || currentSectionId;
    const sourceMedia = html?.querySelector?.(`[data-section="product-media-${sourceSectionId}"]`);
    const destinationMedia = destinationScope?.querySelector?.(`[data-section="product-media-${currentSectionId}"]`);
    const sourceSig = mediaSignature(sourceMedia);
    const destinationSig = mediaSignature(destinationMedia);
    const sameMediaSet = !!sourceSig && !!destinationSig && sourceSig === destinationSig && !this.isCombinedListingsNeedUpdate;
    const originalDisplay = this.dataset.variantMediaDisplay;
    if (sameMediaSet && originalDisplay !== "show_all") this.dataset.variantMediaDisplay = "show_all";
    try {
      return originalUpdateElementsAfterFetch.call(this, html);
    } finally {
      if (sameMediaSet && originalDisplay !== "show_all") this.dataset.variantMediaDisplay = originalDisplay || "";
    }
  };
})();
